export default "__VITE_ASSET__B$gkpBSk__"